var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgHeart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    style: {
      fill: "rgb(233,244,246)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.89828,-0.240693,0.240693,0.89828,-0.833841,2.05448)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 4.242,
    style: {
      fill: "rgb(251,82,82)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.407676,-0.109236,0.109236,0.407676,3.05046,4.77639)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,0.986C9.329,-2.436 17.651,3.551 6,11.25C-5.651,3.552 2.672,-2.436 6,0.986Z",
    style: {
      fill: "rgb(229,244,247)"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgHeart);
export default __webpack_public_path__ + "static/media/bg-heart.6d603fcebb2073c0859eff668388e71b.svg";
export { ForwardRef as ReactComponent };